module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "extend-segment-duration"
    }
  }, [_c('b-modal', {
    ref: "extendSegmentDuration",
    attrs: {
      "id": "modal-extend-segment-duration",
      "noCloseOnBackdrop": true,
      "noCloseOnEsc": true,
      "hide-footer": "",
      "centered": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function() {
        return [_c('h5', [_vm._v("Durée du segment invalide!")])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('div', {
    staticClass: "d-block text-center mb-4"
  }, [_c('h3', [_vm._v("Voulez vous étendre ou couper le segment?")])]), _vm._v(" "), _c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-primary",
      "size": "xl"
    },
    on: {
      "click": _vm.extend
    }
  }, [_vm._v("\n      étendre\n    ")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "outline-primary",
      "size": "xl"
    },
    on: {
      "click": _vm.crop
    }
  }, [_vm._v("\n      Couper\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2bc3acfc","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal/ExtendSegmentDuration.vue
// module id = 821
// module chunks = 1 3